import{ Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-gestione-gruppi-templates',
	templateUrl: './gestione-gruppi-templates.component.html',
	styleUrls: ['./gestione-gruppi-templates.component.css']
})
export class GestioneGruppiTemplatesComponent extends AppComponentGenericComponent implements OnInit {
	headers: HttpHeaders;
	gruppiSync: Subscription;
	gruppi: any[] = [];

	newGruppo: any = {
		codice : '',
		descrizione : ''
	}

	editingGruppo: any = {
		id : '',
		codice : '',
		descrizione : ''
	}

	constructor(protected dataService: DataService) {
		super(dataService, 'gestione-gruppi-templates');
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');
		this.headers.append('Accept', 'application/json');
	}

	ngOnInit() {
		this.gruppiSync = this.dataService.templatesGruppi$.subscribe(
			gruppi => {
				this.gruppi = gruppi;
			});
	}

	reset() {
		this.newGruppo.codice = '';
		this.newGruppo.descrizione = '';
	}

	saveNewGruppo() {
		if (this.newGruppo.codice != '' && this.newGruppo.descrizione != '') {
			this.dataService.insert("templates_gruppi", this.newGruppo, false, (error,newId) => {
				if (error) {
					this.dataService.openMessage('INSERIMENTO GRUPPO','si è verificato un errore');
				}
				else {
					this.dataService.openMessage('INSERIMENTO GRUPPO','Gruppo inserito con successo');
					this.reset();
				}
			});
		}
	}

	editGruppo(gruppo: any) {
		if (gruppo.id != this.editingGruppo.id) {
			this.editingGruppo.id = gruppo.id;
			this.editingGruppo.codice = gruppo.codice;
			this.editingGruppo.descrizione = gruppo.descrizione;
		}
		else {
			this.editingGruppo.id = '';
		}
	}

	deleteGruppo(id: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: id });

		this.dataService.delete("templates_gruppi", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE GRUPPO','si è verificato un errore');
			}
			if(res){
				this.dataService.openMessage('ELIMINAZIONE GRUPPO','Gruppo eliminato con successo');
				this.reset();
			}
		});
	}

	saveEditedGruppo() {
		console.log('salvataggio edited gruppo', this.editingGruppo);
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.editingGruppo.id });

		this.dataService.update("templates_gruppi", localFilters, this.editingGruppo, false, (error,res) => {
			if(res){
				this.dataService.openMessage('MODIFICA GRUPPO','Gruppo modificato con successo');
				this.editingGruppo.id = '';
			}
		});
	}

	undoEditingGruppo() {
		console.log('undo');
		this.editingGruppo.id = '';
	}

	ngOnDestroy() {
		this.gruppiSync.unsubscribe();
	}

}
